<div class="modal-header">
    <h2 class="modal-title">{{ azione }} sopralluoghi/monitoraggi</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
        <ngb-panel id="tab-1" title="Classificazione e caratteristiche costruttive">
            <ng-template ngbPanelContent>

                <div class="row">
                    <div class="form-group col-md-4" [formGroup]="formGroup">
                        <label for="idFunzionePrevalente">Funzione prevalente</label>
                        <input class="form-control" id="idFunzionePrevalente" type="text"
                            [value]="getFunzionePrevalenteDescrizione(formGroup.get('idFunzionePrevalente')?.value)"
                            [disabled]="true">
                    </div>

                    <div class="form-group col-md-4" [formGroup]="formGroup">
                        <label for="macroTipologiaOpera">Macrotipologia opera</label>
                        <input class="form-control" id="macroTipologiaOpera" type="text"
                            [value]="getMacroTipologiaOperaDescrizione(formGroup.get('macroTipologiaOpera')?.value)"
                            [disabled]="true">
                    </div>



                    <div class="form-group col-md-4" [formGroup]="formGroup">
                        <label for="idTipologiaOpera">Tipologia opera</label>
                        <input class="form-control" id="idTipologiaOpera" type="text"
                            [value]="getTipologiaOperaDescrizione(formGroup.get('idTipologiaOpera')?.value)"
                            [disabled]="true">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6" [formGroup]="formGroup">
                        <label for="idMaterialeCostruzione">Materiale costruzione</label>
                        <input class="form-control" id="idMaterialeCostruzione" type="text"
                            [value]="getMaterialeDescrizione(formGroup.get('idMaterialeCostruzione')?.value)"
                            [disabled]="true">
                    </div>

                    <div class="form-group col-md-6" [formGroup]="formGroup">
                        <label for="idMaterialeRivestimento">Materiale rivestimento</label>
                        <input class="form-control" id="idMaterialeRivestimento" type="text"
                            [value]="getMaterialeDescrizione(formGroup.get('idMaterialeRivestimento')?.value)"
                            [disabled]="true">
                    </div>
                </div>
            </ng-template>
        </ngb-panel>
        <ngb-panel id="tab-2" title="Anagrafica sopralluogo/monitoraggio">
            <ng-template ngbPanelContent>
                <div class="modal-body">
                    <form class="form" role="form" [formGroup]="criteriaForm">
                        <div class="form-row">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="idtipologia">Tipologia sopralluogo/monitoraggio*</label>
                                    <select class="form-control" formControlName="idtipologia" id="idtipologia">
                                        <option [ngValue]="null">Seleziona un'opzione...</option>
                                        <option *ngFor="let item of datalist.tipologiaRilevamento" [ngValue]="item.id">
                                            {{
                                            item.descrizione }}</option>
                                    </select>
                                </div>
                                <!--<div class="form-group col-md-4">
                <label for="idfonte">Fonte</label>
                <select class="form-control" formControlName="idfonte" id="idfonte">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.fonte" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>-->
                                <div class="form-group col-md-6">
                                    <app-toolkit-datepicker id="dataesecuzioneRilevamento"
                                        label="Data sopralluogo/monitoraggio"
                                        formControlName="dataesecuzioneRilevamento"
                                        [disabled]="criteriaForm.controls['dataesecuzioneRilevamento'].disabled">
                                    </app-toolkit-datepicker>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="idRilevatore">Rilevatore</label>
                                    <select
                                            class="form-control"
                                            id="idRilevatore"
                                            formControlName="idRilevatore"
                                            [compareWith]="compareRilevatore">
                                        <option [ngValue]="null">Seleziona un'opzione...</option>
                                        <option *ngFor="let r of rilevatori" [ngValue]="r">
                                            {{ r.descrizione }}
                                        </option>
                                    </select>

                                </div>

                                <div class="form-group col-md-6">
                                    <label for="enteRilevatore">Ente Rilevatore</label>
                                    <input
                                            class="form-control"
                                            id="enteRilevatore"
                                            type="text"
                                            formControlName="enterilevatore"
                                            [ngbTooltip]="showEnteTooltip ? 'Attenzione, non inserire dati soggetti a Privacy (nome e cognome)' : null"
                                            container="body">
                                </div>



                                <div class="form-group col-md-4">
                                    <label for="efficienza" class="d-flex align-items-center">
                                        Efficienza – stato dell’opera
                                        <button type="button" class="btn btn-link btn-sm p-0 ml-2"
                                            aria-label="Info efficienza" tabindex="0"
                                            (click)="getEfficienzaInfoSelected()" container="body">
                                            <app-toolkit-bl-icon icon="info-circle"
                                                cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                    </label>
                                    <select class="form-control" formControlName="efficienza" id="efficienza">
                                        <option [ngValue]="null">Seleziona un'opzione...</option>
                                        <option *ngFor="let item of datalist.fascePercentuali" [ngValue]="item.id">{{
                                            item.descrizione }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="efficacia" class="d-flex align-items-center">
                                        Efficacia – utilità opera
                                        <button type="button" class="btn btn-link btn-sm p-0 ml-2"
                                            aria-label="Info efficacia" tabindex="0"
                                            (click)="getEfficaciaInfoSelected()" container="body">
                                            <app-toolkit-bl-icon icon="info-circle"
                                                cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                    </label>
                                    <select class="form-control" formControlName="efficacia" id="efficacia">
                                        <option [ngValue]="null">Seleziona un'opzione...</option>
                                        <option *ngFor="let item of datalist.fascePercentuali" [ngValue]="item.id">{{
                                            item.descrizione }}</option>
                                    </select>

                                </div>
                                <div class="form-group col-md-4">
                                    <label for="linkschedamonitoraggio" class="d-flex align-items-center">
                                        Link scheda monitoraggio
                                    </label>
                                    <!--TODO: DA CAPIRE COME GESTIRE QUESTO LINK-->
                                    <input class="form-control" id="linkschedamonitoraggio"
                                        formControlName="linkschedamonitoraggio" type="text">
                                </div>
                                <div class="form-group col-md-4">
                                    <app-toolkit-datepicker id="dataprossimoispezione"
                                        label="Data prossimo monitoraggio" formControlName="dataprossimaispezione"
                                        [disabled]="criteriaForm.controls['dataprossimaispezione'].disabled">
                                    </app-toolkit-datepicker>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 d-flex justify-content-center">
                                    <h6 class="mb-3">Dati evento</h6>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="idtipoevento">Tipo evento*</label>
                                    <select class="form-control" formControlName="idtipoevento" id="idtipoevento">
                                        <option [ngValue]="null">Seleziona un'opzione...</option>
                                        <option *ngFor="let item of datalist.evento" [ngValue]="item.id">{{
                                            item.descrizione
                                            }}</option>
                                    </select>
                                </div>
                                <div *ngIf="isAltroTipoEvento" class="form-group col-md-4">
                                    <label for="altrotipoevento">Altro tipo evento*</label>
                                    <input class="form-control" id="altrotipoevento" formControlName="altrotipoevento" type="text">
                                </div>
                                <div class="form-group col-md-4">
                                    <app-toolkit-datepicker id="dataevento" label="Data evento*"
                                        formControlName="dataevento"
                                        [disabled]="criteriaForm.controls['dataevento'].disabled">
                                    </app-toolkit-datepicker>
                                </div>
                                <!--<div class="form-group col-md-4">
                <label for="richiestafinanziamento">Richiesta di finanziamento (€)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="richiestafinanziamento" formControlName="richiestafinanziamento" type="text">
            </div>-->
                                <div class="form-group col-md-4">
                                    <label for="entitadanno">Entità danno*</label>

                                    <!-- Modalità modifica/inserimento -->
                                    <select *ngIf="azione !== 'Visualizza'" class="form-control"
                                        formControlName="entitadanno" id="entitadanno">
                                        <option [ngValue]="null">Seleziona un'opzione...</option>
                                        <option *ngFor="let item of datalist.livelloDanno" [ngValue]="item.id">
                                            {{ item.descrizione }}
                                        </option>
                                    </select>

                                    <!-- Modalità visualizzazione con select disabilitata -->
                                    <select *ngIf="azione === 'Visualizza'" class="form-control" disabled>
                                        <option>
                                            {{
                                            entitaDannoLabel
                                            }}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="descrizioneevento">Descrizione evento*</label>
                                    <textarea class="form-control" id="descrizioneevento"
                                        formControlName="descrizioneevento" type="text"></textarea>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="descrizionedanno">Descrizione danno*</label>
                                    <textarea class="form-control" id="descrizionedanno"
                                        formControlName="descrizionedanno" type="text"></textarea>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="propostaintervento">Proposta di intervento</label>
                                    <textarea class="form-control" id="propostaintervento"
                                        formControlName="propostaintervento" type="text"></textarea>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="note">Note</label>
                                    <textarea class="form-control" id="note" formControlName="note"
                                        type="text"></textarea>
                                </div>
                            </div>
                        </div>
                    </form>
                    <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
                </div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
    <div class="modal-footer">
        <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
        <button *ngIf="canEdit" type="button" tabindex="0" (click)="saveMonitoraggiSopralluoghi()"
            class="btn btn-primary">Salva</button>
    </div>